// extracted by mini-css-extract-plugin
export default {"bg":"LoadingComponent_bg__zwY-U","dark":"LoadingComponent_dark__OB2dO"};